import { render, staticRenderFns } from "./Messaggi.vue?vue&type=template&id=c73605ec&"
import script from "./Messaggi.vue?vue&type=script&lang=js&"
export * from "./Messaggi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports